import { DEFAULT_LOCALE } from "../i18n";
/**
 * Generates the full URL for a specific locale.
 */
export const getLocalizedUrl = (
    siteUrl: string,
    basePath: string,
    localeCode: string,
  ): string => {
    // For default locale (en), use the base path directly
    if (localeCode === DEFAULT_LOCALE) {
      return `${siteUrl}${basePath}`;
    }
  
    // For other locales, prepend the locale code
    return `${siteUrl}/${localeCode}${basePath}`;
  };